import {ReactNode} from 'react';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';
import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import Modal from 'patient-ping-remedy/packages/modal';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import {css} from '@emotion/css';
import {colors} from 'patient-ping-remedy/packages/theme';
import {log} from '@/helpers/logger';

type Props = {
  title: string;
  isOpen: boolean;
  close(): void;
  confirm(): Promise<void>;
  disabled?: boolean;
  message?: ReactNode;
  warningText?: string;
}

export default function DeleteModal({ title, isOpen, close, confirm, disabled, message, warningText }: Props) {
  const handleConfirm = async () => {
    try {
      await confirm();
      close();
    } catch (error) {
      log('error', error);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      headerText={`Delete ${title.toLowerCase()}`}
      className={css({width: "70rem"})}
      buttons={[
        <Button key="cancel" styleType={StyleType.TERTIARY} onClick={close}>Cancel</Button>,
        <Button key="confirm" onClick={handleConfirm} disabled={disabled}>Confirm</Button>
      ]}
    >
      <StandardTypography>
        {message ?? `Are you sure you want to delete this ${title.toLowerCase()}?`}
      </StandardTypography>
      {warningText && (
        <p className={css({
          marginTop: '1.2rem',
          color: colors.red5,
        })}>
          <Icon
            iconClass={ICONS['exclamation-triangle']}
            color={colors.red5}
            className={css({ marginRight: '0.6rem' })}
          />
          {warningText}
        </p>
      )}
    </Modal>
  );
}
